import React from 'react'
import { useState } from 'react';
import SingleProjectImgMain from '../assets/images/projects/single_project_img_main.jpg'
import SingleProjectGroupImg1 from '../assets/images/projects/single_project_group_img1.jpg'
import SingleProjectGroupImg2 from '../assets/images/projects/single_project_group_img2.jpg'
import SingleProjectGroupImg3 from '../assets/images/projects/single_project_group_img3.jpg'
import SingleProjectGroupImg4 from '../assets/images/projects/single_project_group_img4.jpg'
import Telephone from '../assets/images/services/telephone.png'
import YouTubeLogo from '../assets/images/services/youtube-logo.png'
import FixHeader from '../component/FixHeader'
import Loader from '../component/Loader'
import LatestBlog from '../component/LatestBlog'
import Footer from '../component/Footer'
import { useNavigate } from 'react-router-dom';

const ProjectDetails2 = () => {
    const navigate = useNavigate()
    const [isPlaying, setIsPlaying] = useState(false);
    const playVideo = () => {
        setIsPlaying(true);
    };
    return (
        <>
            <Loader />
            <FixHeader />
            {/* <!-- ====================================== Services Section One ===================================== --> */}
            <section className="section-breadcrumb-img" id="project-section-one">
                <div className="container breadcrumb-main">
                    <h1 className="about-h1-text" data-aos="fade-down">Single Projects</h1>
                    <ul className="breadcrumb-list about-breadcrumb" data-aos="fade-up">
                        <li className="line-slash" onClick={() => navigate("/")}>Home</li>
                        <li className="line-slash" onClick={() => navigate("/ProjectDetails2")}>Projects</li>
                        <li className="active-breadcrumb" onClick={() => navigate("/ProjectDetails2")}>Single Projects 2</li>
                    </ul>
                </div>
            </section>
            {/* <!-- ====================================== Services Section Two ===================================== --> */}
            <section className="about-section-two pb-0">
                <div className="container">
                    <div className="row single-services1-row single-services2-row">
                        <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-8">
                            <div className="side-bar-main" data-aos="fade-right">
                                <h2 className="d-none">hidden</h2>
                                <h3 className="ServicesList-Text">Project Info</h3>
                                <div>
                                    <p className="case-detail-info"><span>Title :</span> Homely Real Estate</p>
                                    <p className="case-detail-info"><span>Client :</span> Robert Symon</p>
                                    <p className="case-detail-info"><span>Date :</span> 28 January 2024</p>
                                    <p className="case-detail-info"><span>Service Value :</span> $5500</p>
                                    <p className="case-detail-info"><span>Category :</span> Homely Real Estate</p>
                                    <p className="case-detail-info pb-0"><span>Live link :</span> http://demo.com</p>
                                </div>
                            </div>
                            <div className="contact-side-bar aos-init aos-animate" data-aos="fade-up">
                                <img className="telephone-img" src={Telephone} alt="call" />
                                <h4>Get In Touch</h4>
                                <p className="resolving">Ready to assist you in resolving any legal issues you may have.</p>
                                <div className="hire-me-btn-main">
                                    <div onClick={() => navigate("/Contact")} className="button button1" data-text="Contact">
                                        <span>Contact</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-8 col-xl-8 col-lg-12 col-md-12">
                            <div className="video-container2 single-services-main-img">
                                {!isPlaying && (
                                    <>
                                        <img className="cover" src={SingleProjectImgMain} alt="Video Cover" />
                                        <img className="play-button" src={YouTubeLogo} alt="Play Button" onClick={playVideo} />
                                    </>
                                )}
                                <div className="video-wrapper">
                                    {isPlaying && (
                                        <iframe
                                            id="youtube-video"
                                            src="https://www.youtube.com/embed/TqFU1vle48k?si=wBcN42ZkO_ble_yy-&autoplay=1"
                                            frameBorder="0"
                                            allow="autoplay; encrypted-media"
                                            allowFullScreen
                                            title="YouTube Video"
                                        ></iframe>
                                    )}
                                </div>
                            </div>
                            <h2 className="Singleservices-text-main">Homely Real Estate</h2>
                            <p className="commodo">Commodo semper bibendum adipiscing orci bibendum eu lectus sed. Commodo
                                cursus vitae augue luctus nibh. Congue sit quisque volutpat libero tempor a id cursus purus.
                                Pellentesque pellentesque scelerisque curabitur porta dolor. Amet vulputate vitae eget sit
                                rhoncus imperdiet. Odio justo nullam scelerisque quis bibendum. Cras ipsum vel diam praesent
                                tortor at elit sit. A risus molestie bibendum donec blandit adipiscing volutpat sollicitudin
                                aliquam. Nec arcu cras ultrices velit sed ligula. Iaculis elit vulputate sollicitudin
                                quisque ut faucibus.</p>
                            <p className="commodo pt-2">Facilisis nec malesuada enim viverra cras. Auctor dignissim tellus
                                vestibulum vitae hac amet. Suspendisse sit feugiat in pulvinar bibendum arcu nunc id. Duis
                                hac nisl dui facilisi placerat at mauris elit scelerisque. Turpis ornare auctor amet
                                vestibulum in magna aliquet ultricies netus. Adipiscing lobortis a interdum morbi etiam non.
                            </p>
                            <div className="single-services-imgs-group img-animation-style1 reveal active">
                                <img src={SingleProjectGroupImg1} alt="SingleProjectGroupImg1" />
                                <img src={SingleProjectGroupImg2} alt="SingleProjectGroupImg2" />
                                <img src={SingleProjectGroupImg3} alt="SingleProjectGroupImg3" />
                                <img src={SingleProjectGroupImg4} alt="SingleProjectGroupImg4" />
                            </div>
                            <p className="commodo">Facilisis nec malesuada enim viverra cras. Auctor dignissim tellus vestibulum
                                vitae hac amet. Suspendisse sit feugiat in pulvinar bibendum arcu nunc id. Duis hac nisl dui
                                facilisi placerat at mauris elit scelerisque. Turpis ornare auctor amet vestibulum in magna
                                aliquet ultricies netus. Adipiscing lobortis a interdum morbi etiam non. Elit sed magna
                                risus tempor non quis. Nec pulvinar scelerisque in faucibus.</p>
                            <p className="commodo pt-2">Dis morbi cursus aliquam rutrum tortor amet. Mauris consequat libero
                                praesent pellentesque nibh sed eget urna. Leo at feugiat vel dictum eget quam et commodo
                                nullam. Nec arcu egestas adipiscing mollis dapibus justo non.</p>
                            <div className="accordion" id="accordion2">
                                <div className="accordion-item FAQ-accordion" data-aos="fade-up">
                                    <div className="accordion-header" id="faqOne">
                                        <button className="accordion-button accordion-button-collapsed collapsed" type="button"
                                            data-bs-toggle="collapse" data-bs-target="#faqcollapseOne">What is your review
                                            policy?
                                        </button>
                                    </div>
                                    <div id="faqcollapseOne" className="accordion-collapse collapse" aria-labelledby="faqOne"
                                        data-bs-parent="#accordion2">
                                        <div className="accordion-body">
                                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Quia voluptatem
                                            provident aliquam fuga vitae repellat, quaerat sit beatae voluptas cumque nihil,
                                            nulla itaque minus omnis sint repudiandae accusantium facere. Ab!
                                        </div>
                                    </div>
                                </div>
                                <div className="accordion-item FAQ-accordion" data-aos="fade-up">
                                    <div className="accordion-header" id="faqTwo">
                                        <button className="accordion-button accordion-button-collapsed collapsed" type="button"
                                            data-bs-toggle="collapse" data-bs-target="#faqcollapseTwo">What is the typical
                                            turnaround time for content?
                                        </button>
                                    </div>
                                    <div id="faqcollapseTwo" className="accordion-collapse collapse"
                                        data-bs-parent="#accordion2">
                                        <div className="accordion-body">
                                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Quia voluptatem
                                            provident aliquam fuga vitae repellat, quaerat sit beatae voluptas cumque nihil,
                                            nulla itaque minus omnis sint repudiandae accusantium facere. Ab!
                                        </div>
                                    </div>
                                </div>
                                <div className="accordion-item FAQ-accordion" data-aos="fade-up">
                                    <div className="accordion-header" id="faqThree">
                                        <button className="accordion-button accordion-button-collapsed collapsed" type="button"
                                            data-bs-toggle="collapse" data-bs-target="#faqcollapseThree">What types of
                                            content can I order?
                                        </button>
                                    </div>
                                    <div id="faqcollapseThree" className="accordion-collapse collapse"
                                        data-bs-parent="#accordion2">
                                        <div className="accordion-body">
                                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Quia voluptatem
                                            provident aliquam fuga vitae repellat, quaerat sit beatae voluptas cumque nihil,
                                            nulla itaque minus omnis sint repudiandae accusantium facere. Ab!
                                        </div>
                                    </div>
                                </div>
                                <div className="accordion-item FAQ-accordion" data-aos="fade-up">
                                    <div className="accordion-header" id="faqFour">
                                        <button className="accordion-button accordion-button-collapsed collapsed" type="button"
                                            data-bs-toggle="collapse" data-bs-target="#faqcollapseFour">Who are the Crowd
                                            Content writers?
                                        </button>
                                    </div>
                                    <div id="faqcollapseFour" className="accordion-collapse collapse"
                                        data-bs-parent="#accordion2">
                                        <div className="accordion-body">
                                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Quia voluptatem
                                            provident aliquam fuga vitae repellat, quaerat sit beatae voluptas cumque nihil,
                                            nulla itaque minus omnis sint repudiandae accusantium facere. Ab!
                                        </div>
                                    </div>
                                </div>
                                <div className="accordion-item FAQ-accordion" data-aos="fade-up">
                                    <div className="accordion-header" id="faqFive">
                                        <button className="accordion-button accordion-button-collapsed collapsed" type="button"
                                            data-bs-toggle="collapse" data-bs-target="#faqcollapseFive">How much does a
                                            website cost?
                                        </button>
                                    </div>
                                    <div id="faqcollapseFive" className="accordion-collapse collapse"
                                        data-bs-parent="#accordion2">
                                        <div className="accordion-body">
                                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Quia voluptatem
                                            provident aliquam fuga vitae repellat, quaerat sit beatae voluptas cumque nihil,
                                            nulla itaque minus omnis sint repudiandae accusantium facere. Ab!
                                        </div>
                                    </div>
                                </div>
                                <div className="accordion-item FAQ-accordion" data-aos="fade-up">
                                    <div className="accordion-header" id="faqSix">
                                        <button className="accordion-button accordion-button-collapsed collapsed" type="button"
                                            data-bs-toggle="collapse" data-bs-target="#faqcollapseSix">What happens if I
                                            don't like the content?
                                        </button>
                                    </div>
                                    <div id="faqcollapseSix" className="accordion-collapse collapse"
                                        data-bs-parent="#accordion2">
                                        <div className="accordion-body">
                                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Quia voluptatem
                                            provident aliquam fuga vitae repellat, quaerat sit beatae voluptas cumque nihil,
                                            nulla itaque minus omnis sint repudiandae accusantium facere. Ab!
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <LatestBlog />
            <Footer />
        </>
    )
}

export default ProjectDetails2